export enum MenuState {
    CATEGORY = "CATEGORY",
    OPERATOR = "OPERATOR",
    VALUE = "VALUE",
    SAVED_SEARCH = "SAVED_SEARCH"
}